import { jsx as _jsx } from "react/jsx-runtime";
import InsightCarouselWidget from "@widgets/insightCarouselWidget/insightCarouselWidget";
const NewsCarouselWidget = ({ newsCarousel }) => {
    return _jsx(InsightCarouselWidget, { useStaticCards: true, insightCarousel: { apiEndpoint: "NewsCarousel/Items", ...newsCarousel } });
};
export default NewsCarouselWidget;
